import { MotionConfig } from 'motion/react'
import type { ReactNode } from 'react'

/** Las piezas basadas en Motion respetan prefers-reduced-motion del sistema. */
export function ProveedorMovimiento({ children }: { children: ReactNode }) {
  return <MotionConfig reducedMotion="user">{children}</MotionConfig>
}
